// DOCUMENT READY
document.addEventListener("DOMContentLoaded", function () {
  Fancybox.bind("[data-fancybox]", {
    infinite: false,
    Carousel: false,
    Toolbar: {
      display: [
        "counter",
        "zoomIn",
        "zoomOut",
        //"slideshow",
        "fullscreen",
        "zoom",
        "close",
      ],
    },
  });

  // Scroll
  function Scroll() {
    let self = this;

    this.scrollToObject = function (objName, offset = 0) {
      let objPosition = getCoords(document.querySelector(objName)).top;

      $("body, html").animate(
        {
          scrollTop: objPosition - 60 + offset,
        },
        1000
      );
    };

    function getCoords(elem) {
      let box = elem.getBoundingClientRect();

      return {
        top: box.top + window.pageYOffset,
        right: box.right + window.pageXOffset,
        bottom: box.bottom + window.pageYOffset,
        left: box.left + window.pageXOffset,
      };
    }

    let elements = document.querySelectorAll('a[data-action="scroll"]');

    for (let el of elements) {
      el.addEventListener("click", function (e) {
        e.preventDefault();

        let objLink = "";
        objLink = el.getAttribute("href");

        if (objLink.indexOf(".") > 0) {
          objLink = objLink.substring(1);
        }

        if (document.querySelector(objLink)) self.scrollToObject(objLink);
      });
    }
  }

  window.scroll = new Scroll();

  // Spoiler
  window.spoiler = {
    /* Флаг индикатор открытого спойлера
        1 - спойлер открыт, 0 - спойлер закрыт */
    // spoilerFlag: 1,

    // Константа префикса для id основной кнопки переключателя
    SPOILER_TOGGLE_BTN_PREFIX: "spoiler-toggle-",
    // Константа префикса для id карточки
    CARD_PREFIX: "product-card-modif-",
    // Константа имени класса для дополнительной кнопки переключателя
    SPOILER_TOGGLE_BTN_IS_EXTRA_CLS: "is--extra-btn",

    init: function () {
      let self = this;
      let elements = document.querySelectorAll('a[data-action="spoiler"]');

      for (let el of elements) {
        el.addEventListener("click", function (e) {
          e.preventDefault();
          self.toggle($(this));
        });
      }
    },

    /**
     *
     * @param {jQuery} $btn
     * @param {bool} isOpen
     */
    switchSpoilerBtn: function ($btn, isOpen) {
      const textToggle = $btn.data("text-toggle");
      const text = $btn.text();
      const OPEN_CLASS = "open";

      $btn.toggleClass(OPEN_CLASS, isOpen);
      $btn.data("text-toggle", text);
      $btn.text(textToggle);
    },

    toggle: function ($this) {
      const self = this;
      const isExtraBtn =
        $this.hasClass(self.SPOILER_TOGGLE_BTN_IS_EXTRA_CLS) ||
        !$this.attr("id");
      const spoilerSelector = $this.attr("href");
      const $spoiler = $(spoilerSelector);
      const spoilerIsVisible = $spoiler.is(":visible");
      const spoilerId = spoilerSelector.replace("#", "");
      const cardSelector = `#${self.CARD_PREFIX}${spoilerId}`;
      const $card = $(cardSelector);

      if ($card.length) {
        $card.toggleClass("is--open", !spoilerIsVisible);
      }

      if (isExtraBtn) {
        const btnSelector = "#" + self.SPOILER_TOGGLE_BTN_PREFIX + spoilerId;
        const $btn = $(btnSelector);

        if ($btn.length) {
          self.switchSpoilerBtn($btn, !spoilerIsVisible);

          if (spoilerIsVisible && window.scroll) {
            window.scroll.scrollToObject(
              $card.length ? cardSelector : btnSelector,
              -160
            );
          }
        }
      } else {
        self.switchSpoilerBtn($this, !spoilerIsVisible);
      }

      if (spoilerIsVisible) {
        $spoiler.fadeOut();
      } else {
        $spoiler.fadeIn();
      }
    },
  };

  window.spoiler.init();
});
